function BaseController(){
	this.className			= "BaseController";
	this.glob				= "/**";
	this.globUseHash		= false;
	this.priority			= 10000;
	this.debug				= false;
	this.views				= false;
};
BaseController.inheritsFrom( StandardController );
BaseController.prototype.swapMain = function(onComplete){

	if(!this.isSetup){
		this.$body 				= $("body");
		this.$scrollElement		= $("body, html");	// what to scroll when navigating with aviator
		this.$header 			= this.$body.find(".js-site-header");
		this.$jsBody			= this.$body.find(".js-body");
		this.$page 				= this.$jsBody.find(".js-page");

		this.themes 			= this.getMeta().themes;
		this.makePageCover();

		// Update images with src-wait attribute before load.
		jcache.setImagesSrcWait(this.$jsBody);

		//debugger;

		this.clickable = new Clickable();
	}

	if(this.views){
		this.runViews(onComplete);
	}else{
		this.runDefault(onComplete);
	}

	return false;
};
BaseController.prototype.runDefault = function(onComplete){
	// setting up aviator stage for the first time
	if(!this.isSetup) {
		this.isSetup = true;

	}else{

		// LOAD PAGE CACHE
		const state = nav.getState();
		const cache = jcache.getCache(state.nextUrl);
		const $page = cache.$get(".js-body",false);
		this.$jsBody.html($page);

		const match = cache.raw.match(/<body[^>]*?class="([a-zA-Z0-9\-_\s]+)"[^>]*>/);
		let bodyClass = match ? match[1] : "";

		// Add data-BodyClass to body class.
		const dataBodyClass = this.$jsBody.find('.js-page').attr('data-bodyClass');
		if(dataBodyClass){
			bodyClass = `${bodyClass} ${dataBodyClass}`;
		}

		this.$body.attr("class",bodyClass);

		this.$header.attr("class", cache.$quickGet(".js-site-header").attr("class"));

		// Only scroll to top if not hash link.
		if(!state.nextHash){
			this.$scrollElement.scrollTop(0);
		}
	}

	// elements that need recognising after every page load (as they change)
	this.$page = this.$jsBody.find(".js-page");

    let imagesLoaded = false;
    let videosLoaded = false;

    const checkMediaLoaded = function(){
        if (imagesLoaded && videosLoaded) {
            onComplete();
        }
    };

	// Process images
	const imageCount = this.processImages(this.$body, function() {
        imagesLoaded = true
        checkMediaLoaded();
    });
	const videoCount = this.processVideos(this.$body, function() {
        videosLoaded = true;
        checkMediaLoaded();
    });

	// Add all links to aviator
	nav.addToLinks($("a:not(.no-auto-link)"));
	// nav.addToLinks($("a"));

	gsap.registerPlugin(ScrollTrigger);

	// On mobile (like iPhone Safari) → GSAP ignores height-only resizes (toolbar changes)
	ScrollTrigger.config({
		ignoreMobileResize: true
	});
	gsap.registerPlugin(CustomEase);

	return false;
}
BaseController.prototype.runViews = function(onComplete){
	// setting up aviator stage for the first time
	if(!this.isSetup){

		// Setup view model
		this.viewModel = new ViewModel();
		this.viewModel.addListener('ready', (e) => {
			onComplete();
		});

		this.isSetup = true;

	}else{
		onComplete();
	}
}
BaseController.prototype.swap = function(onComplete){
	return true;
};
BaseController.prototype.on = function(onComplete){
	return true;
};
BaseController.prototype.onMain = function(onComplete){
	this.clickable.run();

	this.$body.css("visibility","visible");

	if(typeof(ga) !== "undefined"){ //needs checking
		if(this.hasDoneFirstPage){
			ga('send', 'pageview', nav.getState().nextUrl);
		}
		this.hasDoneFirstPage = true;
	}

	if (this.$cover) {
		this.$cover.stop().animate({opacity:0},{duration:750});
		onComplete();

		return false;
	}

	return true;
}
BaseController.prototype.offMain = function(onComplete){
	if (!this.$cover) return onComplete();

	// If navigating to/from homepage add class to hide regular and hero logos.
	const state = nav.getState();
	const nextIsHomepage = state.nextUrl === "/" || state.nextUrl === "/home/";
	const previousIsHomepage = state.previousUrl === "/" || state.previousUrl === "/home/";
	this.$siteLogo = this.$header.find(".site-logo");
	this.$siteHeroLogo = this.$page.find(".site-logo--hero");
	this.$siteLogo.toggleClass("site-logo--homepage", nextIsHomepage);
	this.$siteHeroLogo.toggleClass("site-logo--homepage", previousIsHomepage);


	const bc = this.themes[nav.getState().nextParts[0]] ?? "light";
	this.$cover
		.removeClass((index, className) => (className.match(/\btheme\-\-[a-z]+/)||[])[0])
		.addClass("theme--"+bc)
		.stop().animate({opacity:1},{duration:500, complete: () => {
			onComplete();
		}
	});

	return false;
}
BaseController.prototype.off = function(onComplete){
	return true;
}
BaseController.prototype.makePageCover = function(){
	const theme = (this.$body.attr("class").match(/theme\-\-[a-z]+/)||[""])[0];
	this.$cover = $(`<div class="site-cover js-site-cover ${theme}" style="pointer-events:none;position:fixed;z-index:2;top:0;left:0;width:100%;height:100%;"></div>`);
	this.$jsBody.before(this.$cover);
}
BaseController.prototype.processImages = function($container, onComplete){
	if(!$container) $container = this.$body;

	this.imageController = new ImageController();
	this.imageController.addListener("ready",Igloo.delegate(this, function(){
		onComplete();
	}));

	const imageCount = this.imageController.$process($container);

	return imageCount;
}
BaseController.prototype.processVideos = function($container, onComplete){
	if(!$container) $container = this.$body;

	this.videoController = new VideoController();
	this.videoController.addListener("ready",Igloo.delegate(this, function(){
		onComplete();
	}));

	const videoCount = this.videoController.$process($container);

	return videoCount;
}
BaseController.prototype.isDevice = function(device){
	return $("body").find("." + device).is(":visible");
}
BaseController.prototype.isMobile = function(){
	return this.isDevice('mobile');
}
